
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as CopyIconComponent } from "./copy-icon.svg";

export const CopyIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <CopyIconComponent {...props} />;
};
